if (!customElements.get('pickup-availability')) {
  customElements.define(
    'pickup-availability',
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        if (!this.hasAttribute('available')) return;

        this.errorHtml = this.querySelector('template').content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        if (!variantId) return;

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith('/')) {
          rootUrl = rootUrl + '/';
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, 'text/html')
              .querySelector('.shopify-section');
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector('button');
            if (button) button.removeEventListener('click', this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute('available');
          this.innerHTML = '';
        }
      }

      renderError() {
        this.innerHTML = '';
        this.appendChild(this.errorHtml);

        this.querySelector('button').addEventListener('click', this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector('pickup-availability-drawer');
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector('pickup-availability-accordion')) {
          this.innerHTML = '';
          this.removeAttribute('available');
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector('pickup-availability-accordion').outerHTML;
        this.setAttribute('available', '');

        // Initialize accordion functionality
        this.initializeAccordion();
      }

      initializeAccordion() {
        const accordion = this.querySelector('pickup-availability-accordion');
        if (!accordion) return;

        const toggle = accordion.querySelector('.pickup-availability-toggle');
        const content = accordion.querySelector('.pickup-availability-content');
        const header = accordion.querySelector('.pickup-availability-header');

        if (toggle && content) {
          // Add click handler to toggle button
          toggle.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            this.toggleAccordion(accordion, content, toggle);
          });

          // Add click handler to header for better UX
          header.addEventListener('click', (e) => {
            if (e.target !== toggle) {
              this.toggleAccordion(accordion, content, toggle);
            }
          });
        }
      }

      toggleAccordion(accordion, content, toggle) {
        const isExpanded = accordion.getAttribute('data-expanded') === 'true';
        
        if (isExpanded) {
          // Collapse
          accordion.setAttribute('data-expanded', 'false');
          content.style.display = 'none';
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          // Expand
          accordion.setAttribute('data-expanded', 'true');
          content.style.display = 'block';
          toggle.setAttribute('aria-expanded', 'true');
        }
      }
    }
  );
}

// Custom element for pickup availability accordion
if (!customElements.get('pickup-availability-accordion')) {
  customElements.define(
    'pickup-availability-accordion',
    class PickupAvailabilityAccordion extends HTMLElement {
      constructor() {
        super();
        console.log('PickupAvailabilityAccordion constructor called');
        this.initializeAccordion();
      }

      initializeAccordion() {
        console.log('Initializing accordion...');
        const toggle = this.querySelector('.pickup-availability-toggle');
        const content = this.querySelector('.pickup-availability-content');
        const header = this.querySelector('.pickup-availability-header');

        console.log('Toggle found:', !!toggle);
        console.log('Content found:', !!content);
        console.log('Header found:', !!header);

        if (toggle && content) {
          // Add click handler to toggle button
          toggle.addEventListener('click', (e) => {
            console.log('Toggle button clicked!');
            e.preventDefault();
            e.stopPropagation();
            this.toggleAccordion();
          });

          // Add click handler to header for better UX
          if (header) {
            header.addEventListener('click', (e) => {
              if (e.target !== toggle) {
                console.log('Header clicked!');
                this.toggleAccordion();
              }
            });
          }
        } else {
          console.log('Missing required elements for accordion');
        }
      }

      toggleAccordion() {
        console.log('toggleAccordion called');
        const content = this.querySelector('.pickup-availability-content');
        const toggle = this.querySelector('.pickup-availability-toggle');
        const isExpanded = this.getAttribute('data-expanded') === 'true';
        
        console.log('Current state - isExpanded:', isExpanded);
        
        if (isExpanded) {
          // Collapse
          console.log('Collapsing accordion');
          this.setAttribute('data-expanded', 'false');
          content.style.display = 'none';
          toggle.setAttribute('aria-expanded', 'false');
        } else {
          // Expand
          console.log('Expanding accordion');
          this.setAttribute('data-expanded', 'true');
          content.style.display = 'block';
          toggle.setAttribute('aria-expanded', 'true');
        }
      }
    }
  );
}

// Fallback: Add direct event listeners for accordion functionality
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, setting up pickup availability accordion fallback');
  
  // Function to initialize accordion
  function initializeAccordionFallback() {
    const accordions = document.querySelectorAll('pickup-availability-accordion');
    console.log('Found accordions:', accordions.length);
    
    accordions.forEach((accordion, index) => {
      console.log(`Initializing accordion ${index + 1}`);
      
      const toggle = accordion.querySelector('.pickup-availability-toggle');
      const content = accordion.querySelector('.pickup-availability-content');
      const header = accordion.querySelector('.pickup-availability-header');
      
      console.log(`Accordion ${index + 1} - Toggle:`, !!toggle, 'Content:', !!content, 'Header:', !!header);
      
      if (toggle && content) {
        // Remove any existing listeners
        toggle.removeEventListener('click', handleToggleClick);
        if (header) {
          header.removeEventListener('click', handleHeaderClick);
        }
        
        // Add new listeners
        toggle.addEventListener('click', handleToggleClick);
        if (header) {
          header.addEventListener('click', handleHeaderClick);
        }
        
        console.log(`Accordion ${index + 1} listeners added`);
      }
    });
  }
  
  function handleToggleClick(e) {
    console.log('Toggle clicked via fallback');
    e.preventDefault();
    e.stopPropagation();
    toggleAccordionFallback(this);
  }
  
  function handleHeaderClick(e) {
    const toggle = e.currentTarget.querySelector('.pickup-availability-toggle');
    if (e.target !== toggle) {
      console.log('Header clicked via fallback');
      toggleAccordionFallback(toggle);
    }
  }
  
  function toggleAccordionFallback(toggle) {
    const accordion = toggle.closest('pickup-availability-accordion');
    const content = accordion.querySelector('.pickup-availability-content');
    const isExpanded = accordion.getAttribute('data-expanded') === 'true';
    
    console.log('Fallback toggle - isExpanded:', isExpanded);
    
    if (isExpanded) {
      accordion.setAttribute('data-expanded', 'false');
      content.style.display = 'none';
      toggle.setAttribute('aria-expanded', 'false');
    } else {
      accordion.setAttribute('data-expanded', 'true');
      content.style.display = 'block';
      toggle.setAttribute('aria-expanded', 'true');
    }
  }
  
  // Initialize immediately
  initializeAccordionFallback();
  
  // Also initialize when new content is added (for dynamic updates)
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1 && (node.tagName === 'PICKUP-AVAILABILITY-ACCORDION' || node.querySelector('pickup-availability-accordion'))) {
            console.log('New accordion detected, reinitializing...');
            setTimeout(initializeAccordionFallback, 100);
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});

// Keep drawer functionality for backward compatibility
if (!customElements.get('pickup-availability-drawer')) {
  customElements.define(
    'pickup-availability-drawer',
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector('button').addEventListener('click', () => {
          this.hide();
        });

        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest('pickup-availability-drawer') &&
          target.id != 'ShowPickupAvailabilityDrawer'
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.removeEventListener('click', this.onBodyClick);
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute('open', '');
        document.body.addEventListener('click', this.onBodyClick);
        document.body.classList.add('overflow-hidden');
        trapFocus(this);
      }
    }
  );
}
